import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { useProductPageContext } from '../../../productPageContext'

export const useProductAddToCartCtaShouldShowSelectErxModal = (): boolean => {
  const { currentPrescriptionType } = useProductPageContext()

  return (
    [
      PrescriptionPrescriptionTypeEnum.InsurancePrescription,
      PrescriptionPrescriptionTypeEnum.FreePrescription,
    ] as PrescriptionPrescriptionTypeEnum[]
  ).includes(currentPrescriptionType)
}
